<template>
    <section class="container-fluid my-4">
      <h4 class="my-4">Declaração de <strong>matrícula</strong></h4>
  
      <form @submit.prevent="generateFile">
        <div class="row">
          <div class="form-group col-md-6">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <SearchableSelect
                    v-model="student_id"
                    :options="students"
                    :loading="loadingStudents"
                    :remote-search="true"
                    :debounce-delay="500"
                    :min-search-length="0"
                    item-text="name"
                    item-value="id"
                    label="Aluno"
                    placeholder="-- Selecione um aluno --"
                    @input="teamByStudent"
                    @search="searchStudents"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <SearchableSelect
                    v-model="team_id"
                    :options="teamsOfstudent.map(r => r.team)"
                    item-text="name"
                    item-value="id"
                    label="Turma"
                    placeholder="-- Selecione uma turma --"
                  />
                </div>
              </div>
            </div>
  
            <div v-if="!loading" class="form-group text-center my-2">
              <button
                type="submit"
                class="btn btn-success btn-sm mx-2 text-uppercase"
              >
                Gerar
              </button>
              <button
                type="reset"
                class="btn btn-secondary btn-sm text-uppercase"
                @click="clearForm"
              >
                Limpar
              </button>
            </div>
  
            <LoadingPage v-else />
          </div>
        </div>
      </form>
  
      <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">
        VOLTAR
      </button>
    </section>
  </template>
  
  <script>
  import api from "@/services";
  import LoadingPage from "@/components/LoadingPage.vue";
  import SearchableSelect from "@/components/SearchableSelect.vue";
  import { handleBlobError } from "@/helpers";
  import studentSearchMixin from "@/mixins/studentSearchMixin";
  
  export default {
    name: "RegistrationStatement",
    mixins: [studentSearchMixin],
    components: {
      LoadingPage,
      SearchableSelect,
    },
    data() {
      return {
        team_id: "",
        student_id: "",
        loading: false,
        teamsOfstudent: [],
      };
    },
    methods: {
      async teamByStudent(studentId) {
        this.teamsOfstudent = [];
        this.team_id = "";
  
        // Salva o aluno selecionado (método do mixin)
        this.saveSelectedStudent(studentId);
        
        if (this.selectedStudent) {
          this.teamsOfstudent = this.selectedStudent.registrations ?? [];
        }
      },
      clearForm() {
        this.student_id = "";
        this.team_id = "";
        this.teamsOfstudent = [];
        // Limpa a seleção de aluno (método do mixin)
        this.clearStudentSelection();
      },
      async generateFile() {
  
        if (!this.team_id || !this.student_id)
          return Toast.fire("Erro", "Por favor, selecione todos os campos.", "error");
  
        try {
  
          this.loading = !this.loading;
  
          await api
  
            .get(`/exports/registration-statement/${this.student_id}/team/${this.team_id}`,{ responseType: "blob"})
            .then((response) => {
  
              const blob = new Blob([response.data], { type: "application/pdf" });
  
              const a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = `Declaração de matrícula - ` + this.teamsOfstudent[0].student.name.toUpperCase();     
              a.click();
  
            });
        } catch (error) {
          handleBlobError(error, (message) => {
            Toast.fire('Erro', message, "error");
          });
        }
        this.loading = !this.loading;
      },
    },
    mounted() {
      this.getStudents();
    },
  };
  </script>
  
  <style scoped></style>
  